export default __webpack_public_path__ + "static/media/camion.ed5a6f03.webp";